// extracted by mini-css-extract-plugin
export default {"hovered":"telegram_hovered__PLLEu","bw_circle":"telegram_bw_circle__pYSBI","bw_stars":"telegram_bw_stars__UsCXQ","stars":"telegram_stars__Uc5xr"};